import { Link, MenuItem, Typography } from '@mui/material';
import React, { useRef } from 'react';

import { NAV_COLOR_PALETTE } from '../../Components/styleConstants';
import { IProfileSettingsOptions } from '../../types';

import { DATA_OG, DATA_TEST } from '../../enums';

const textStyles = {
  backgroundColor: 'inherit',
  fontWeight: 600,
  color: NAV_COLOR_PALETTE.primaryGray
};

const menuStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px',
  width: '100%',
  px: 3
};

export const MobileProfileOptionsMenu: React.FC<
  Pick<
    IProfileSettingsOptions,
    'updateProfileUrl' | 'handleSignOut' | 'updateProfileOnClick' | 'updateProfileLinkComponent'
  > & {
    autoFocusFirstItem?: boolean;
    firstTrayMenuItemRef?: React.MutableRefObject<HTMLLIElement>;
    closeUtilityMenu(): void;
  }
> = ({
  updateProfileUrl,
  handleSignOut,
  updateProfileOnClick,
  updateProfileLinkComponent,
  autoFocusFirstItem,
  firstTrayMenuItemRef,
  closeUtilityMenu
}) => {
  if (updateProfileUrl && updateProfileOnClick) {
    console.error('Both updateProfileUrl and updateProfileOnClick are provided. Only one should be provided.');
  }
  const profileLinkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      {(updateProfileUrl || updateProfileOnClick) && (
        <MenuItem
          ref={firstTrayMenuItemRef}
          autoFocus={autoFocusFirstItem}
          data-test={DATA_TEST.my_profile_link}
          data-og={DATA_OG.my_profile_link}
          onClick={() => {
            closeUtilityMenu();
            if (updateProfileOnClick) updateProfileOnClick();

            // Since item is a link, click inner Link component
            // (important for keyboard navigation & general accessibility)
            if (profileLinkRef?.current && updateProfileUrl) profileLinkRef.current.click();
          }}
          sx={menuStyles}
        >
          {updateProfileUrl && (
            <Link
              href={updateProfileUrl}
              ref={profileLinkRef}
              component={updateProfileLinkComponent || 'a'}
              variant="bodyDefault"
              sx={{
                ...textStyles,
                textDecoration: 'none',
                ':visited': {
                  color: NAV_COLOR_PALETTE.primaryGray
                }
              }}
              tabIndex={-1}
            >
              My Profile
            </Link>
          )}
          {updateProfileOnClick && (
            <Typography component="span" sx={textStyles}>
              My Profile
            </Typography>
          )}
        </MenuItem>
      )}
      {handleSignOut && (
        <MenuItem
          ref={!updateProfileUrl ? firstTrayMenuItemRef : undefined}
          autoFocus={!updateProfileUrl && autoFocusFirstItem}
          data-test={DATA_TEST.handle_sign_out}
          data-og={DATA_OG.handle_sign_out}
          onClick={() => {
            handleSignOut();
            closeUtilityMenu();
          }}
          sx={menuStyles}
        >
          <Typography component="span" sx={textStyles}>
            Log Out
          </Typography>
        </MenuItem>
      )}
    </>
  );
};
